
export enum NOTE_TYPES {
  CRM_NOTE = 'CRM_NOTE',
  CRM_NOTE_OVERVIEW = 'CRM_NOTE_OVERVIEW',
  COMPANY_NOTE_OVERVIEW = 'COMPANY_NOTE_OVERVIEW',
}


export interface RecentNoteData {
  crmId: number;
  [NOTE_TYPES.CRM_NOTE]: {id: number, containerId: number, spaceId: number, updated: string};
  [NOTE_TYPES.CRM_NOTE_OVERVIEW]: {id: number, containerId: number, spaceId: number, updated: string};
  [NOTE_TYPES.COMPANY_NOTE_OVERVIEW]: {id: number, containerId: number, spaceId: number, updated: string};
}
